import gql from "graphql-tag";
import {responseField} from "../../base.graphql";
import {roleFields} from "../system-configurations/temp-fcrs/system-user/system-user.graphql";

export const userProfile = `
id
profileUniqueId
userFirstName
userLastName
userEmail
profilePhone
profileTitle
profilePhoto
profileType
profileGender
profileIsActive
`;


export const userRoles =`
  id
  uniqueId
  name
  description
  rolePermissions {
    id
    uniqueId
    permissionName
    permissionCode
  }
`;

export const institutionUserProfileFields = `
  id
  uniqueId
  userType
  userProfile {
    ${userProfile}
  }
  profileRole {
    ${userRoles}
  }
  isActive
  createdDate
`;

export const userDetailsFields = `
id
uniqueId
accountType
userProfile {
  ${userProfile}
}
isActive
createdDate
profileRole {
  ${userRoles}
}
`

export const GET_USER_PROFILE= gql`
query GetUserProfile {
  getUserProfile {
    data {
      id
      userProfile {
        ${userProfile}
      }
      userRoles {
        ${userRoles}
      }
    }
    response {
      id
      status
      code
      message
    }
  }
}
`;


export const GET_COMPLAINANT_PROFILE = gql`
  query getComplainantProfile{
    getComplainantProfile{
      response {
        ${responseField}
      }
      data {
        ${userProfile}
      }
    }
  }
`;

export const GET_USER_PROFILE_AND_ROLES = gql`
  query getUserProfileAndRoles {
    getUserProfileAndRoles {
      data {
        id
        uniqueId
        firstName
        lastName
        email
        phone
        photo
        accountType
        isActive
        createdDate
        role {
          id
          uniqueId
          roleName
          roleIsSuperAdmin
          roleDescription
          roleCreateddate
          permissions {
            id
            uniqueId
            permissionName
            permissionCode
            isGlobal
            permissionCreateddate
          }
        }
      }
      response {
        id
        status
        code
        message
      }
    }
  }
`;

export const GET_USER_DETAILS = gql`
query GetUserDetails {
  getUserDetails {
      response {
        ${responseField}
      }
      data {
        ${userDetailsFields}
      }
    }
  }
`;

export const GET_RESET_LINK = gql`
  mutation ForgotPasswordMutation($email: String!) {
    forgotPasswordMutation(email: $email) {
      response {
        ${responseField}
      }
    }
  }
`;

export const RESET_PASSWORD = gql`
  mutation ActivateOrResetPasswordMutation($input: SetOrResetPasswordInputObject) {
    activateOrResetPasswordMutation(input: $input) {
      response {
        ${responseField}
      }
    }
  }
`;


export const CREATE_COMPLAINANT_USER = gql`
mutation createComplainantUserMutation($input: ProfileInputObject) {
  createComplainantUserMutation(input: $input) {
    response {
      ${responseField}
    }
  }
}
`;


export const UPDATE_COMPLAINANT_USER = gql`
mutation updateUserProfileMutation($input: ProfileInputObject) {
  updateUserProfileMutation(input: $input) {
    response {
      ${responseField}
    }
    data {
      ${userDetailsFields}
    }
  }
}
`;


export const VERIFY_OTP = gql`
mutation verifyOtpMutation($otp: Int!, $phoneNumber: String!) {
  verifyOtpMutation(otp: $otp, phoneNumber: $phoneNumber) {
    response {
      ${responseField}
    }
  }
}
`;


export const RESEND_OTP = gql`
mutation resendOtpMutation($phoneNumber: String) {
  resendOtpMutation(phoneNumber: $phoneNumber) {
    resendTime
    response {
      ${responseField}
    }
  }
}
`;


export const VERIFY_PHONE_NUMBER = gql`
mutation VerifyPhoneNumberMutation($phoneNumber: String!, $verificationType: VerificationTypeChoices!) {
  verifyPhoneNumberMutation(phoneNumber: $phoneNumber, verificationType: $verificationType) {
    response {
      ${responseField}
    }
  }
}
`;
